import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { Paths } from "@/common/paths/paths";
import { getString } from "@/common/uistringlabels/ui-string-utils";

export const AssetNotFound: FC = () => (
  <Col gridGap="S300">
    <Text>{getString("replacement.chooseDevice.assetNotFound")}</Text>
    <Link href={Paths.myHardware.url}>{getString("replacement.chooseDevice.backToMyHardware")}</Link>
  </Col>
);
